<!-- 2c 订单详情，需要固定形式 -->
<template>
  <div class="order-detail clearfix">
    <div class="side col-left clearfix">
      <div class="product-logo-wrap">
        <img class="product-logo" v-if="order.pic" :src="order.pic" alt="order.productName">
      </div>
      <div class="side-info">
        <div class="product-name">{{ order.productName }}</div>
        <div class="order-price">
          <template v-if="order.payOutPrice">
            {{ order.payOutPrice | fen2yuan }}
          </template>
          <template v-else>
            {{ order.orderPrice | fen2yuan }}
          </template>
        </div>
        <div class="order-state">{{ order.orderStatusName }}</div>
      </div>
    </div>
    <hr class="hr visible-xs-block">
    <div class="main col-right">
      <dl>
        <dt>{{ $t('orderNum') }}</dt>
        <dd>{{ order.orderNum }}</dd>
      </dl>
      <dl>
        <dt>{{ $t('placeorderTime') }}</dt>
        <dd>{{ order.orderTime}}</dd>
      </dl>

      <dl>
        <dt>联系人</dt>
        <dd>{{ order.userName }}</dd>
      </dl>

      <dl>
        <dt>联系电话</dt>
        <dd>{{ order.tel }}</dd>
      </dl>

      <dl>
        <dt>取件地址</dt>
        <dd>{{ order.addr }}</dd>
      </dl>

      <dl>
        <dt>收款方式</dt>
        <dd>{{ order.payInfo && order.payInfo.payWayName }}</dd>
      </dl>

      <dl>
        <dt>回收方式</dt>
        <dd>{{ order.recycleTypeName}}</dd>
      </dl>

      <ul class="imgs" v-if="order.userPics && order.userPics.length">
        <li class="img-item" v-for="(pic, index) in order.userPics" :key="index">
          <img class="img" :src="pic" @click="imgView(pic)">
        </li>
      </ul>
      <div class="overtime-warn" v-if="$t('orderDetail.overtimeWarn')">{{ $t('orderDetail.overtimeWarn') }}</div>
      <div class="order-actions clearfix">
        <h-button class="h-btn btn-lg" size="large" v-show="order.canCancel === '1'" @click="cancelOrder">{{ $t('cancelOrder') }}</h-button>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { Button as hButton } from 'hsb_recycle_components';
import { Message } from 'element-ui';

export default {
  data () {
    return {
      dialogVisible: false,
      preimgsrc: ''
    };
  },
  components: {
    hButton
  },
  computed: {
    order () {
      return this.$store.state.orderItem.orderInfo;
    },
    error () {
      return this.$store.state.orderItem.error;
    }
  },
  methods: {
    async cancelOrder () {
      this.$emit('cancelOrder');
    },
    remarkOrder () {
      this.$emit('remarkOrder');
    },
    imgView (pic) {
      this.dialogVisible = true;
      this.preimgsrc = pic;
    }
  },
  watch: {
    error (val) {
      if (val) {
        Message.error(val);
        this.$store.commit('orderItem/setError', '');
      }
    }
  }
};
</script>

<style scoped>

@import 'config.css';

.fl {
  float: left;
}

.fr {
  float: right;
}

.order-detail {
  background-color: #fff;
}

.side {
  text-align: center;
}

.product-name {
  margin-top: 18px;
  font-size: 18px;
  font-weight: bold;
}

.order-price {
  margin-top: 22px;
  font-size: 20px;
  color: #C23838;
}

.order-state {
  margin-top: 22px;
  font-size: 14px;
}

.product-logo {
  height: 206px;
}

.main {
  /*width: 788px;*/
  /*margin-left: 64px;*/
  dt, dd {
    margin: 0;
    display: inline-block;
  }
  dt {
    width: 100px;
    color: #666666;
  }
  dl {
    margin-bottom: 32px;
  }
  .h-btn {
    display: inline-block;
    width: 198px;
    margin-right: 36px;
  }
  .overtime-warn {
    margin: 20px 0;
    font-size: 12px;
    color: #AE6D6D;
  }
}

.select-list {
  padding: 24px 0;
  margin-top: 26px;
  border-top: 1px solid #E6E6E6;
}

.select-item {
  float: left;
  width: 33%;
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 1.8;
}
.imgs {
  font-size: 0;
  margin-bottom: 20px;
}
.img-item {
  display: inline-block;
  width: 80px;
  height: 80px;
  margin-right: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  border-radius: $global-border-radius;

  .img {
    width: 100%;
    height: 100%;
  }
}

@media (--sm-viewport) {
  .side {
    width: 100%;
    .product-logo-wrap {
      float: left;
    }
    .side-info {
      float: left;
    }
  }
  .product-logo {
    height: 152px;
  }
  .main {
    width: 100%;
    margin: 0;
    padding: 16px;
    padding-top: 0;
    dl {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .h-btn {
      width: 100%;
      padding: 0;
      margin-right: 0;
      box-sizing: content-box;
      &:nth-of-type(2) {
        float: right;
      }
    }
  }
  .select-item {
    width: 100%;
  }
/*
  .main .h-btn.block {
    width: 100%;
  }*/

  .img-item {
    width: 80px;
  }
}
</style>
